import { FragmentRESTSerializer as RESTSerializer } from 'ember-data-model-fragments/serializer';

export default class User extends RESTSerializer {
  normalize(model, hash, prop) {
    let defaults = {
      mfaFactors: {},
      disabled: false,
    };
    Object.assign(defaults, hash);
    hash = defaults;
    return super.normalize(model, hash, prop);
  }
}
